import { Component } from '@builder.io/sdk';

export const config: Component = {
    name: 'Tooltip',
    inputs: [
        {
            name: 'title',
            type: 'string',
            defaultValue: '',
        },
        {
            name: 'description',
            type: 'longText',
            defaultValue: '',
        },
        {
            name: 'variant',
            type: 'string',
            defaultValue: 'dark',
            enum: [
                {
                    label: 'Dark',
                    value: 'dark',
                },
                {
                    label: 'Light',
                    value: 'light',
                },
            ],
        },
        {
            name: 'hasArrow',
            type: 'boolean',
            defaultValue: true,
        },
        {
            name: 'side',
            type: 'string',
            defaultValue: 'top',
            enum: [
                {
                    label: 'Top',
                    value: 'top',
                },
                {
                    label: 'Left',
                    value: 'left',
                },
                {
                    label: 'Right',
                    value: 'right',
                },
                {
                    label: 'Bottom',
                    value: 'bottom',
                },
            ],
        },
        {
            name: 'defaultOpen',
            type: 'boolean',
            defaultValue: false,
            enum: [
                {
                    label: 'Yes',
                    value: true,
                },
                {
                    label: 'No',
                    value: false,
                },
            ],
        },
    ],
    defaultChildren: [
        {
            '@type': '@builder.io/sdk:Element',
            component: { name: 'Text', options: { text: 'Your content here.' } },
        },
    ],
};
